var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"code-wrap rounded-lg relative mx-auto p-4",staticStyle:{"background-color":"#272822"}},[_c('div',{staticClass:"mx-auto w-min",domProps:{"innerHTML":_vm._s(_vm.clean_text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }